<mbs-table-grid [data]="licenses || []"
                [entityName]="'licenses:title' | i18next: { format: 'title' }"
                [headers]="headers"
                [loading]="loading"
                [maxHeight]="tableMaxHeight"
                [minHeight]="'50px'">
  <ng-template let-license
               mbsTableCell>
    {{ license.displayName }}
  </ng-template>

  <ng-template let-license
               mbsTableCell>
    {{ license.periodStart | date : 'MMMM y' }}
  </ng-template>

  <ng-template let-license
               mbsTableCell>
    {{ license.storageVolume + ' GB' }}
  </ng-template>

  <ng-template let-license
               mbsTableCell>
    {{ license.deletedDataSize + ' GB' }}
  </ng-template>

  <ng-template let-license
               mbsTableCell>
    {{ license.priceBy1GB | pricePrepayment | async}}
  </ng-template>

  <ng-template let-license
               mbsTableCell>
    {{ license.totalCost | pricePrepayment | async}}
  </ng-template>

</mbs-table-grid>

<b *ngIf="total" class="text-end w-100 d-block mt-3">Total {{ total | pricePrepayment | async}}</b>
